import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Switch, withRouter } from 'react-router-dom';
import { ProtectedRoute } from '../helpers/ProtectedRoute';
import AreasCreate from '../components/areas/AreasCreate';
import CommonAreas from '../components/areas/CommonAreas';
import Reservations from '../components/areas/Reservations';

const BanksRoutes = ({ match: { url } }) =>
  <Switch>
    <ProtectedRoute exact rols={['manager', 'safety', 'property']} path={`${url}`} component={CommonAreas} />
    <ProtectedRoute exact rols={['manager', 'safety', 'property']} path={`${url}/:id/reservations`} component={Reservations} />
    <ProtectedRoute exact rols={['manager']} path={`${url}/:type(create|\\d+/edit)`} component={AreasCreate} />
    <Redirect to="/errors/404" />
  </Switch>

BanksRoutes.propTypes = { match: PropTypes.object.isRequired };

export default withRouter(BanksRoutes);